import { ALL_CIUDADES, LOADING_ALL_CIUDADES } from './CiudadesReducer';
import { allCiudadesService } from './CiudadesService';

export const allCiudadesAction = async (dispatch, idEstado) => {
  dispatch({ type: LOADING_ALL_CIUDADES, payload: true });

  try {
    const res = await allCiudadesService(idEstado);
    if (res.status === 200) {
      dispatch({
        type: ALL_CIUDADES,
        payload: res.data,
      });
      dispatch({ type: LOADING_ALL_CIUDADES, payload: false });
      return true;
    }
  } catch (e) {
    console.log(e.message);
    dispatch({ type: LOADING_ALL_CIUDADES, payload: false });
  }
};
